import { useTRPC } from "@/trpc/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function invalidate(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: [["apps"]] });
}

export function useInitiateAppConnection() {
  const trpc = useTRPC();
  return useMutation(trpc.apps.initiateConnection.mutationOptions());
}

export function useDisconnectApp() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.apps.disconnect.mutationOptions(),
    onSuccess: () => invalidate(qc),
  });
}
